import React from 'react';
import GameBody from './GameBody.tsx';
import { FaArrowsAltV } from "react-icons/fa";

const GameTable = () => {

    return (
        <>
            <div className='container-tablePending mt-3'>
                <div className='header-table-game'>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-3'></div>
                    <div className='col-lg-1 col-md-1 col-sm-1 col-xs-1 text-aling'>
                        <span>Score</span><FaArrowsAltV className='icon-game' />
                    </div>
                    <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2 text-aling'>
                        <span>SPREAD</span>
                    </div>
                    <div className='col-lg-1 col-md-1 col-sm-1 col-xs-1 text-aling'>
                        <span>MONEYLINE</span>
                    </div>
                    <div className='col-lg-2 col-md-2 col-sm-2 col-xs-2 text-aling'>
                        <span>TOTAL</span>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-3 col-xs-3 text-aling'>
                        <span>TEAM TOTALS</span>
                    </div>
                </div>
            </div>
            <div className='league-container'>
                <span>LEGAUE</span>
            </div>
            <div className='date-league'>
                <span>Date</span>
            </div>
            <GameBody />
        </>
    )
}

export default GameTable;